import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgClockHistoryCircleGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M8.023 1.482a1 1 0 1 1 .525 1.93 9 9 0 0 0-.398.117 1 1 0 0 1-.61-1.904q.24-.077.483-.143'
      opacity={0.1}
    />
    <path
      fill={props.color}
      d='M3.697 3.968A1 1 0 0 1 5.143 5.35a6.7 6.7 0 0 0-1.176 1.707 1 1 0 1 1-1.798-.876 8.7 8.7 0 0 1 1.528-2.212'
      opacity={0.2}
    />
    <path
      fill={props.color}
      d='M1.067 10.421a1 1 0 0 1 1.992.176Q3 11.269 3 11.998c0 1.46.178 2.746.531 3.85a1 1 0 1 1-1.904.61C1.197 15.114 1 13.615 1 11.998q0-.81.067-1.577'
      opacity={0.3}
    />
    <path
      fill={props.color}
      d='M3.97 20.302a1 1 0 1 1 1.382-1.447c1.49 1.423 3.7 2.143 6.648 2.143q2.193 0 3.85-.532a1 1 0 0 1 .61 1.905c-1.344.43-2.843.627-4.46.627-3.247 0-6.037-.794-8.03-2.696'
      opacity={0.4}
    />
    <path
      fill={props.color}
      d='M11.268 1.986A1 1 0 0 0 12.254 3c2.89.041 5.05.794 6.5 2.244C20.246 6.736 21 8.981 21 11.998c0 2.947-.72 5.158-2.143 6.648a1 1 0 1 0 1.447 1.381C22.206 18.034 23 15.245 23 11.998c0-3.324-.832-6.168-2.832-8.168-1.943-1.943-4.684-2.784-7.886-2.83a1 1 0 0 0-1.014.986'
      opacity={0.5}
    />
    <path
      fill={props.color}
      d='M13 7a1 1 0 1 0-2 0v6a1 1 0 0 0 .293.707l2.328 2.328a1 1 0 1 0 1.415-1.414L13 12.586z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgClockHistoryCircleGhostLine)
export default ForwardRef
